import React, {useEffect, useRef, useState} from 'react';
import {syncCustomer} from '@/api/customer';
import {PageGrid, TwoColumnLayout} from '@/component';
import {Button, Input, message, Card, Select, Spin, Space} from 'antd';
import {TagOutlined} from '@/icons';
import styles from '../index.module.less';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {getColumns} from '@/page/customer/CustomPage/customerColumns';
import TagModal from '@/page/customer/CustomPage/TagModal';
import AppLayout from '@/page/component/AppLayout';
import AppLayoutHeader from '@/page/component/AppLayout/AppLayoutHeader';
import {useEditAuthService} from '@/page/admin/adminService';

const {Option} = Select;

function CustomPage() {
    const editable = useEditAuthService(['global:customer_mgr:w']);
    const tagRef = useRef();
    const tableRef = useRef();
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.id');
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchParam, setSearchParam] = useState({
        name: '',
        follow: '',
        type: 0,
        userId: userId,
    });

    const extra = (
        <Space.Compact>
            <Input
                className={styles.baseSearch}
                placeholder="请输入客户名称"
                onChange={changeName}
            />
            <Input
                className={styles.baseSearch}
                placeholder="请输入跟进员工编号或名称"
                onChange={changeFollow}
            />
            <Select defaultValue="0" className={styles.baseSelect} onChange={changeSelect}>
                <Option value="0">全部</Option>
                <Option value="1">微信客户</Option>
                <Option value="2">企业微信客户</Option>
            </Select>
            <Button type="primary" onClick={search}>
                查询
            </Button>
            {/*<Button*/}
            {/*    disabled={!editable}*/}
            {/*    type="primary"*/}
            {/*    icon={<SyncOutlined />}*/}
            {/*    style={{marginLeft: '10px'}}*/}
            {/*    onClick={sync}*/}
            {/*>*/}
            {/*    同步*/}
            {/*</Button>*/}
            {/*<Button*/}
            {/*    disabled={!editable}*/}
            {/*    type="primary"*/}
            {/*    style={{marginLeft: '10px'}}*/}
            {/*    onClick={exportExcel}*/}
            {/*>*/}
            {/*    导出*/}
            {/*</Button>*/}
        </Space.Compact>
    );
    let columns = getColumns();
    columns.push({
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        render: (text, record) => (
            <Button
                disabled={!editable}
                type="text"
                onClick={() => edit(record)}
                icon={<TagOutlined />}
                style={{color: '#152D85'}}
            >
                添加标签
            </Button>
        ),
    });
    useEffect(() => {
        setUrl('/customer/list');
    }, []);

    function changeName(e) {
        let temp = {...searchParam};
        temp.name = e.target.value;
        setSearchParam(temp);
    }

    function changeFollow(e) {
        let temp = {...searchParam};
        temp.follow = e.target.value;
        setSearchParam(temp);
    }

    function changeSelect(e) {
        let temp = {...searchParam};
        temp.type = parseInt(e, 10);
        setSearchParam(temp);
    }

    function search() {
        const {name, type, userId, follow} = searchParam;
        setUrl(
            `/customer/list?name=${encodeURIComponent(name)}&type=${encodeURIComponent(
                type
            )}&userId=${encodeURIComponent(userId)}&follow=${encodeURIComponent(follow)}`
        );
    }

    function sync() {
        setLoading(true);
        syncCustomer(userId).then(res => {
            setLoading(false);
            message.success('同步成功');
            search();
        });
    }


    function edit(record) {
        tagRef.current.open(record.id);
    }

    function reload() {
        tableRef.current.refresh();
    }

    return (
        <AppLayout header={<AppLayoutHeader subTitle="客户列表" />}>
        <TwoColumnLayout>
            <TwoColumnLayout.ContentPanel>
                <div className={styles.header}>
                    <Card title="客户列表" extra={extra} />
                </div>
                <Spin spinning={loading}>
                    <div className={styles.tableContainer}>
                        {searchParam && url && (
                            <PageGrid
                                url={url}
                                columns={columns}
                                initParams={searchParam}
                                ref={tableRef}
                            />
                        )}
                        <TagModal ref={tagRef} reload={reload} />
                    </div>
                </Spin>
            </TwoColumnLayout.ContentPanel>
        </TwoColumnLayout>
        </AppLayout>
    );
}

export default CustomPage;
